import React, { memo } from 'react'
import './SwitchButton.scss'

const SwitchButton = (props) => {
  const { className = '', onClick, disabled, checked } = props
  return <input type='checkbox' disabled={disabled} checked={checked} onClick={onClick} className={`custom-switch ${className}`} />
}

export default memo(SwitchButton)
